// Container эхлэхэд docker-entrypoint-env.sh үүсгэсэн window.__ENV__ (public/env-config.js)
// байвал түүнийг, үгүй бол build хийх үед орсон process.env-г ашиглана.
export default function env(name) {
  const runtime = window.__ENV__ || {};
  return runtime[name] !== undefined ? runtime[name] : process.env[name];
}
